import { fetchRatios } from "./ratios";

/* ================= TOKENIZER ================= */

const TOKEN_RULES = [
  { type: "LOGIC", regex: /^(AND|OR)\b/i },
  { type: "OP", regex: /^(>=|<=|>|<|=)/ },
  { type: "LPAREN", regex: /^\(/ },
  { type: "RPAREN", regex: /^\)/ },
  { type: "MATH", regex: /^(\+|\-|\*|\/)/ },
  /* { type: "NUMBER", regex: /^\d+(\.\d+)?/ }, */
  { type: "NUMBER", regex: /^\d+(\.\d+)?%?/ },
  {
    type: "RATIO",
    regex: /^(?!AND\b|OR\b)[A-Za-z_]+(?:\s+(?!AND\b|OR\b)[A-Za-z_]+)*/
  }
];
let LABELS = [];
let FIELD_ALIASES = {};
let RATIOS = {};

export async function initQueryEngine() {
  const data = await fetchRatios();
  LABELS = data.LABELS;
  FIELD_ALIASES = data.FIELD_ALIASES;
  RATIOS = data.RATIOS;
}

/* const LABEL_TO_KEY = (() => {
  const map = {};
  

  LABELS?.forEach(label => {
    const normalizedLabel = label.name
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_|_$/g, "");

    // Find matching DB key from RATIOS
    const match = Object.keys(RATIOS).find(
      dbKey => dbKey === normalizedLabel || dbKey.replace("_", "") === normalizedLabel.replace("_", "")
    );

    if (match) {
      map[label.toLowerCase()] = match;
    }
  });

  return map;
})(); */



export function tokenize(input) {
  let s = input.trim();
  const tokens = [];

  while (s.length) {
    let matched = false;

    for (const r of TOKEN_RULES) {
      const m = s.match(r.regex);
      if (m) {
        tokens.push({ type: r.type, value: m[0].trim() });
        s = s.slice(m[0].length).trim();
        matched = true;
        break;
      }
    }

    if (!matched) throw new Error(`Invalid character near "${s.slice(0, 10)}"`);
  }

  return tokens;
}

//const normalize = v => v.toLowerCase().replace(/\s+/g, "_");
/* function normalize(label) {
  const key = LABEL_TO_KEY[label.toLowerCase().trim()];
  return key || null;
} */
function normalizeLabel(str) {
  return str
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

/* ================= VALIDATION ================= */

export function validate(tokens) {
  
  
  
  for (const token of tokens) {
    if (token.type === "RATIO") {
      const normalized = normalizeLabel(token.value);

      const dbKey = FIELD_ALIASES[normalized];

      if (!dbKey) {
        throw new Error(`Unknown ratio "${token.value}"`);
      }

      // Attach DB key to token for SQL builder
      token.dbKey = dbKey;
    }
  }
}

/* ================= PARSER ================= */

export function parse(tokens) {
  let i = 0;

  const expr = () => {
    let left = term();
    while (tokens[i] && tokens[i].type === "LOGIC") {
      const op = tokens[i++].value;
      const right = term();
      left = { type: "LOGIC", op, left, right };
    }
    return left;
  };

  const term = () => {
    if (tokens[i].type === "LPAREN") {
      i++;
      const e = expr();
      i++; // )
      return e;
    }
    return cond();
  };

  const cond = () => {
    const left = math();
    const op = tokens[i++].value;
    const right = math();
    return { type: "COND", left, op, right };
  };

  const math = () => {
    let node = val();
    while (tokens[i] && tokens[i].type === "MATH") {
      const op = tokens[i++].value;
      const r = val();
      node = { type: "MATH", op, left: node, right: r };
    }
    return node;
  };

  const val = () => {
    const t = tokens[i++];
    if (t.type === "NUMBER") return { type: "NUMBER", value: t.value.replace("%", "") };
    if (t.type === "RATIO") return { type: "RATIO", value: normalizeLabel(t.value), dbKey: t.dbKey };
    throw new Error("Invalid expression");
  };

  return expr();
}

/* ================= SQL for EAV ================= */

function fieldSQL(label) {
  return `(SELECT value FROM ratio_values rv
           WHERE rv.security_id = rd.security_id
           AND rd.${label} IS NOT NULL AND rv.label = '${label}')`;
}

export function buildSQL(ast) {
  console.log("AST:", JSON.stringify(ast, null, 2));
  if (ast.type === "LOGIC")
    return `(${buildSQL(ast.left)} ${ast.op} ${buildSQL(ast.right)})`;

  if (ast.type === "COND")
    return `${buildSQL(ast.left)} ${ast.op} ${buildSQL(ast.right)}`;

  if (ast.type === "MATH")
    return `(${buildSQL(ast.left)} ${ast.op} ${buildSQL(ast.right)})`;

  if (ast.type === "RATIO") return fieldSQL(ast.dbKey);
  if (ast.type === "NUMBER") return ast.value;
}
